export default [
    {
        path: "/Lookup/Index",
        name: "LookupIndex",
        component: () => import("@/components/Lookup/Index.vue"),
        meta: {
            name: "LookupIndex",
            menuTitle: "Lookup",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Lookup/Editor",
        name: "LookupEditor",
        component:  () => import("@/components/Lookup/Editor.vue"),
        meta: {
            name: "LookupEditor",
            menuTitle: "Lookup",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/User/Index",
        name: "UserIndex",
        component: () => import("@/components/User/Index.vue"),
        meta: {
            name: "UserIndex",
            menuTitle: "User",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/User/Editor",
        name: "UserEditor",
        component:  () => import("@/components/User/Editor.vue"),
        meta: {
            name: "UserEditor",
            menuTitle: "User",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Group/Index",
        name: "GroupIndex",
        component: () => import("@/components/Group/Index.vue"),
        meta: {
            name: "GroupIndex",
            menuTitle: "Group",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Group/Editor",
        name: "GroupEditor",
        component:  () => import("@/components/Group/Editor.vue"),
        meta: {
            name: "GroupEditor",
            menuTitle: "Group",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Department/Index",
        name: "DepartmentIndex",
        component: () => import("@/components/Department/Index.vue"),
        meta: {
            name: "DepartmentIndex",
            menuTitle: "Department",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Department/Editor",
        name: "DepartmentEditor",
        component:  () => import("@/components/Department/Editor.vue"),
        meta: {
            name: "DepartmentEditor",
            menuTitle: "Department",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Company/Index",
        name: "CompanyIndex",
        component: () => import("@/components/Company/Index.vue"),
        meta: {
            name: "CompanyIndex",
            menuTitle: "Company",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Company/Editor",
        name: "CompanyEditor",
        component:  () => import("@/components/Company/Editor.vue"),
        meta: {
            name: "CompanyEditor",
            menuTitle: "Company",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Menu/Index",
        name: "MenuIndex",
        component: () => import("@/components/Menu/Index.vue"),
        meta: {
            name: "MenuIndex",
            menuTitle: "Menu",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Mail_Log/Index",
        name: "Mail_LogIndex",
        component: () => import("@/components/Mail_Log/Index.vue"),
        meta: {
            name: "Mail_LogIndex",
            menuTitle: "Mail Log",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Setting/Index",
        name: "SettingIndex",
        component: () => import("@/components/Setting/Index.vue"),
        meta: {
            name: "SettingIndex",
            menuTitle: "Setting",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Setting/Editor",
        name: "SettingEditor",
        component:  () => import("@/components/Setting/Editor.vue"),
        meta: {
            name: "SettingEditor",
            menuTitle: "Setting",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Directorate/Index",
        name: "DirectorateIndex",
        component: () => import("@/components/Directorate/Index.vue"),
        meta: {
            name: "DirectorateIndex",
            menuTitle: "Directorate",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Directorate/Editor",
        name: "DirectorateEditor",
        component:  () => import("@/components/Directorate/Editor.vue"),
        meta: {
            name: "DirectorateEditor",
            menuTitle: "Directorate",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Division/Index",
        name: "DivisionIndex",
        component: () => import("@/components/Division/Index.vue"),
        meta: {
            name: "DivisionIndex",
            menuTitle: "Division",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Division/Editor",
        name: "DivisionEditor",
        component:  () => import("@/components/Division/Editor.vue"),
        meta: {
            name: "DivisionEditor",
            menuTitle: "Division",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Employee/Index",
        name: "EmployeeIndex",
        component: () => import("@/components/Employee/Index.vue"),
        meta: {
            name: "EmployeeIndex",
            menuTitle: "Employee",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Employee/Index/:title",
        name: "EmployeesIndex",
        component: () => import("@/components/Employee/Index.vue"),
        meta: {
            name: "EmployeesIndex",
            menuTitle: "List (not been assessed)",
            requiresAuth: true
        },
        props: true
    },    
    {
        path: "/Employee/Editor",
        name: "EmployeeEditor",
        component:  () => import("@/components/Employee/Editor.vue"),
        meta: {
            name: "EmployeeEditor",
            menuTitle: "Employee",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Functional/Index",
        name: "FunctionalIndex",
        component: () => import("@/components/Functional/Index.vue"),
        meta: {
            name: "FunctionalIndex",
            menuTitle: "Functional",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Functional/Editor",
        name: "FunctionalEditor",
        component:  () => import("@/components/Functional/Editor.vue"),
        meta: {
            name: "FunctionalEditor",
            menuTitle: "Functional",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Grade/Index",
        name: "GradeIndex",
        component: () => import("@/components/Grade/Index.vue"),
        meta: {
            name: "GradeIndex",
            menuTitle: "Grade",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Grade/Editor",
        name: "GradeEditor",
        component:  () => import("@/components/Grade/Editor.vue"),
        meta: {
            name: "GradeEditor",
            menuTitle: "Grade",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/JobStatus/Index",
        name: "JobStatusIndex",
        component: () => import("@/components/JobStatus/Index.vue"),
        meta: {
            name: "JobStatusIndex",
            menuTitle: "Job Status",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/JobStatus/Editor",
        name: "JobStatusEditor",
        component:  () => import("@/components/JobStatus/Editor.vue"),
        meta: {
            name: "JobStatusEditor",
            menuTitle: "Job Status",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Position/Index",
        name: "PositionIndex",
        component: () => import("@/components/Position/Index.vue"),
        meta: {
            name: "PositionIndex",
            menuTitle: "Position",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Position/Editor",
        name: "PositionEditor",
        component:  () => import("@/components/Position/Editor.vue"),
        meta: {
            name: "PositionEditor",
            menuTitle: "Position",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Section/Index",
        name: "SectionIndex",
        component: () => import("@/components/Section/Index.vue"),
        meta: {
            name: "SectionIndex",
            menuTitle: "Section",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Section/Editor",
        name: "SectionEditor",
        component:  () => import("@/components/Section/Editor.vue"),
        meta: {
            name: "SectionEditor",
            menuTitle: "Section",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Superior/Index",
        name: "SuperiorIndex",
        component: () => import("@/components/Superior/Index.vue"),
        meta: {
            name: "SuperiorIndex",
            menuTitle: "Approval (Superior)",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Superior/Editor",
        name: "SuperiorEditor",
        component:  () => import("@/components/Superior/Editor.vue"),
        meta: {
            name: "SuperiorEditor",
            menuTitle: "Superior",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Unit/Index",
        name: "UnitIndex",
        component: () => import("@/components/Unit/Index.vue"),
        meta: {
            name: "UnitIndex",
            menuTitle: "OU (Unit)",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Unit/Editor",
        name: "UnitEditor",
        component:  () => import("@/components/Unit/Editor.vue"),
        meta: {
            name: "UnitEditor",
            menuTitle: "Unit",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Role/Index",
        name: "RoleIndex",
        component: () => import("@/components/Role/Index.vue"),
        meta: {
            name: "RoleIndex",
            menuTitle: "Role",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Role/Editor",
        name: "RoleEditor",
        component:  () => import("@/components/Role/Editor.vue"),
        meta: {
            name: "RoleEditor",
            menuTitle: "Role",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Period_History/Index",
        name: "Period_HistoryIndex",
        component: () => import("@/components/Period_History/Index.vue"),
        meta: {
            name: "Period_HistoryIndex",
            menuTitle: "Period History",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Period_History/Editor",
        name: "Period_HistoryEditor",
        component:  () => import("@/components/Period_History/Editor.vue"),
        meta: {
            name: "Period_HistoryEditor",
            menuTitle: "Period History",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Criteria/Index",
        name: "CriteriaIndex",
        component: () => import("@/components/Criteria/Index.vue"),
        meta: {
            name: "CriteriaIndex",
            menuTitle: "Criteria",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Criteria/Editor",
        name: "CriteriaEditor",
        component:  () => import("@/components/Criteria/Editor.vue"),
        meta: {
            name: "CriteriaEditor",
            menuTitle: "Criteria",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Org_Unit/Index",
        name: "Org_UnitIndex",
        component: () => import("@/components/Org_Unit/Index.vue"),
        meta: {
            name: "Org_UnitIndex",
            menuTitle: "Org_Unit",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Org_Unit/Editor",
        name: "Org_UnitEditor",
        component:  () => import("@/components/Org_Unit/Editor.vue"),
        meta: {
            name: "Org_UnitEditor",
            menuTitle: "Org_Unit",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Method_Func/Index",
        name: "Method_FuncIndex",
        component: () => import("@/components/Method_Func/Index.vue"),
        meta: {
            name: "Method_FuncIndex",
            menuTitle: "Method_Func",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Method_Func/Editor",
        name: "Method_FuncEditor",
        component:  () => import("@/components/Method_Func/Editor.vue"),
        meta: {
            name: "Method_FuncEditor",
            menuTitle: "Method_Func",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Question/Index",
        name: "QuestionIndex",
        component: () => import("@/components/Question/Index.vue"),
        meta: {
            name: "QuestionIndex",
            menuTitle: "Question",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Question/Editor",
        name: "QuestionEditor",
        component:  () => import("@/components/Question/Editor.vue"),
        meta: {
            name: "QuestionEditor",
            menuTitle: "Question",
            requiresAuth: true
        },
        props: true
    }            
]   